// extracted by mini-css-extract-plugin
export var table = "_vl-0";